import { useQueryClient, useMutation } from "react-query";
import { updateUserPermission } from "../../../../../actions/Utilities/ModuleManagement";
import { toast } from "../../../../../components/toastNotification";

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    (userPermissions) => updateUserPermission(userPermissions),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(["AllUser"]);
        if (res) {
          if (res.statusCode === 500 || res.statusCode === 400) {
            toast.fire("Server Error", "Cannot display data", "error");
          }
        } else {
          toast.fire(
            "Success",
            "User Permission has been updated successfully.",
            "success"
          );
        }
        // queryClient.invalidateQueries(["user", userId]);
      },
    }
  );

  return mutate;
};
